import Vue from 'vue';
import VueTippy from 'vue-tippy';

Vue.use(VueTippy, {
  arrow: true,
  placement: 'right',
  inertia: true,
  animation: 'shift-toward',
  duration: '[600, 300]',
  delay: '[0, 350]',
  theme: 'purple',
  distance: 20,
  interactive: true
});



// WEBPACK FOOTER //
// ./src/plugins/vue-tippy.js